import { render } from "./Request1.vue?vue&type=template&id=38028b0d"
import script from "./Request1.vue?vue&type=script&lang=js"
export * from "./Request1.vue?vue&type=script&lang=js"

import "./Request1.vue?vue&type=style&index=0&id=38028b0d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__